<template>
  <div class="container-fluid">
    <v-toolbar dense src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"><v-spacer></v-spacer></v-toolbar>
    <OrderForm :order="defaultItem"></OrderForm>
  </div>
</template>

<script>
import OrderForm from '@/components/forms/order/OrderForm.vue'

export default {
  name: 'NewOrderView',
  components: { OrderForm },
  data () {
    return {
      defaultItem: {
        dates: [],
        id: null,
        shoppingCart: {
          boarders: [],
          user: null,
          diet: {},
          dietId: null,
          order: false,
          customPackaging: 1,
          deliveryType: 'Rozvoz',
          paymentTypeId: 1,
          description: null,
          items: {}
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
